import { useEffect, useState } from "react";
import { api, type Summary, type UserSettings } from "../lib/api.js";
import { AuthGate } from "../components/AuthGate.js";
import { ErrorText, yen } from "../components/ui.js";
import { RewardButton } from "../components/RewardButton.js";

export function SummaryPage() {
  return (
    <AuthGate>
      <SummaryInner />
    </AuthGate>
  );
}

function SummaryInner() {
  const [year, setYear] = useState(String(new Date().getFullYear()));
  const [s, setS] = useState<Summary | null>(null);
  const [settings, setSettings] = useState<UserSettings | null>(null);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    api.summary(year).then(setS).catch(setError);
    api.settings().then(setSettings).catch(() => {});
  }, [year]);

  const years = Array.from({ length: 5 }, (_, i) => String(new Date().getFullYear() - i));
  const csvUnlocked = !!settings?.csvExportUntil && settings.csvExportUntil > new Date().toISOString();

  return (
    <section>
      <div className="row between">
        <h1>集計</h1>
        <select className="input" value={year} onChange={(e) => setYear(e.target.value)}>
          {years.map((y) => (
            <option key={y} value={y}>
              {y}年
            </option>
          ))}
        </select>
      </div>
      <ErrorText error={error} />
      {s && (
        <>
          <div className="card">
            <dl className="dl">
              <dt>クロス実績</dt>
              <dd>
                {s.crossCount}件{s.notExecutedCount > 0 && <span className="muted">（未実施 {s.notExecutedCount}件）</span>}
              </dd>
              <dt>予想コスト合計</dt>
              <dd>{yen(s.estTotal)}</dd>
              <dt>実績コスト合計</dt>
              <dd>
                {yen(s.actualTotal)} <span className="muted">（実績入力 {s.actualCount}件）</span>
              </dd>
              <dt>優待</dt>
              <dd>
                {s.yutaiCount}件 / 価値の目安 {yen(s.yutaiValue)}
              </dd>
              <dt>純益の目安</dt>
              <dd>
                <strong>{yen(s.netBenefit)}</strong>
              </dd>
            </dl>
            <p className="muted">純益 = 優待価値 − コスト（実績があれば実績、なければ予想）。優待価値は優待マスタの目安です。</p>
          </div>
          <div className="card">
            <h2>証券会社別</h2>
            <table className="table">
              <thead>
                <tr>
                  <th>証券会社</th>
                  <th>件数</th>
                  <th>予想手数料</th>
                  <th>実績手数料</th>
                </tr>
              </thead>
              <tbody>
                {Object.values(s.byBroker).map((b) => (
                  <tr key={b.name}>
                    <td>{b.name}</td>
                    <td>{b.count}</td>
                    <td>{yen(b.estFee)}</td>
                    <td>{yen(b.actualFee)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="card">
            <h2>月別</h2>
            <table className="table">
              <thead>
                <tr>
                  <th>月</th>
                  <th>件数</th>
                  <th>予想コスト</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(s.byMonth)
                  .sort()
                  .map(([m, v]) => (
                    <tr key={m}>
                      <td>{m}</td>
                      <td>{v.count}</td>
                      <td>{yen(v.estTotal)}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="card">
            <h2>CSV ダウンロード</h2>
            {csvUnlocked ? (
              <a className="btn primary" href={api.summaryCsvUrl(year)} download>
                {year}年のクロス実績を CSV で保存
              </a>
            ) : (
              <RewardButton kind="csv_export" label="24時間 CSV を解放する" onGranted={(until) => setSettings((cur) => (cur ? { ...cur, csvExportUntil: until } : cur))} />
            )}
          </div>
        </>
      )}
    </section>
  );
}
